import React, { useState, memo, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { cycleClosingConsolidationWrapperByCycleClosing } from '../../../shared/queries/CycleClosing';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import Header from './Header';
import GraphQL from '../../../GraphQL';
import { getRoundPercentageWithSymbol } from '../../../shared/utils/smartutils';

const ConsolidationGridMaintenance = (props) => {
  const { t, dto, showLoading, hideLoading } = props;
  const [wrapper, setWrapper] = useState({});

  const studentsColumn = (array) => {
    return (
      <div className="student-wrapper flex-column">
        <div className="student-box-header">
          <span className="student-name">{t('general.student')}</span>
        </div>
        {array.map((item) => (
          <div key={item.studentId} className="student-box">
            <span className="student-name">{item.studentName}</span>
          </div>
        ))}
      </div>
    );
  };

  const getColorFrequency = (frequency, minFrequency) => {
    return frequency >= minFrequency ? 'high-frequency' : 'low-frequency';
  };

  const getColorAverage = (average, minAverage) => {
    return average >= minAverage ? 'high-score' : 'low-score';
  };

  const loadCycleClosingConsolidationWrapperByCycleClosing = (selectedDto) => {
    showLoading();
    const query = cycleClosingConsolidationWrapperByCycleClosing(selectedDto);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        if (res.cycleClosingConsolidationWrapperByCycleClosing) {
          setWrapper(res.cycleClosingConsolidationWrapperByCycleClosing);
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
        }
      })
      .catch((error) => {
        hideLoading();
        if (error) {
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
        }
      });
  };

  useEffect(() => {
    loadCycleClosingConsolidationWrapperByCycleClosing(dto);
  }, []);

  return (
    <>
      <Header cycleName={dto.cycleName} subjectName={dto.subject.name} />
      {wrapper &&
      wrapper.consolidationData &&
      wrapper.consolidationData.length ? (
        <div className="form__form-group">
          <div className="consolidation-cycle-grid-container">
            {studentsColumn(wrapper.consolidationData)}
            <div className="wrapper-consolidation-info">
              <div className="consolidation-box-container">
                {[t('general.average'), t('general.frequency-percent')].map(
                  (item) => (
                    <div key={item} className="consolidation-box-header">
                      <span className="student-name">{item}</span>
                    </div>
                  )
                )}
              </div>
              {wrapper.consolidationData.map((item) => (
                <div
                  key={item.studentId}
                  className="consolidation-box-container"
                >
                  <div className="consolidation-box">
                    <span
                      className={`pill ${getColorAverage(
                        item.average,
                        wrapper.minAverage
                      )}`}
                    >
                      {item.average}
                    </span>
                  </div>
                  <div className="consolidation-box">
                    <span
                      className={`pill frequency high-frequency ${getColorFrequency(
                        item.frequency,
                        wrapper.minFrequency
                      )}`}
                    >
                      {getRoundPercentageWithSymbol(item.frequency)}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

ConsolidationGridMaintenance.propTypes = {
  t: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  showLoading: PropTypes.func.isRequired,
  hideLoading: PropTypes.func.isRequired,
};

export default withTranslation('common')(memo(ConsolidationGridMaintenance));
